import { ref } from 'vue'
import axios from 'axios'
import { usePage } from '@inertiajs/vue3'

interface StartSubscriptionParams {
  planId: string
  seats: number
  couponCode: string
}

export const useStripeTeamSubscription = () => {
  const page = usePage()
  const errors = ref(null)
  const isLoading = ref(false)

  const startSubscription = async ({
    planId,
    seats,
    couponCode,
  }: StartSubscriptionParams) => {
    errors.value = null
    isLoading.value = true
    try {
      const {
        data: { checkout_session_stripe_id },
      } = await axios.post('/stripe/open_team_checkout_session', {
        plan_id: planId,
        seats,
        success_path: '/thank-you-for-subscribing-teams',
        coupon_code: couponCode,
        metadata: {
          action: 'start',
        },
      })

      // eslint-disable-next-line no-undef
      const stripe = Stripe(page.props.stripePublicKey)
      stripe.redirectToCheckout({ sessionId: checkout_session_stripe_id })
    } catch ({ message }) {
      errors.value = message
    } finally {
      isLoading.value = false
    }
  }

  return {
    startSubscription,
    errors,
    isLoading,
  }
}
